export class Controller {

    /** @ngInject */
    constructor($translate) {
        this.$translate = $translate;
    }

    $onInit() {
    }

    templateUrl() {
        return require(`./info-sharing-accounts-${this.$translate.use()}.html`);
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/info-sharing-accounts/info-sharing-accounts.controller.js